const RTWProcess = {
    MANUAL: 1,
    IDVT: 2,
    SHARE_CODE: 3
}
export default RTWProcess;